export default {
  methods: {
    canAuthenticate (platform) {
      switch (platform.name || platform) {
        case 'facebook':
        case 'messenger':
        case 'twitter':
        case 'twitterDM':
        case 'instagram':
        case 'instagram_dm':
        case 'h4mail':
        case 'whatsapp_official':
        case 'whatsapp_gupshup':
          return true
        default:
          return false
      }
    }
  }
}
